module.exports = __webpack_public_path__ + "img/vincenzo.ac485799.png";